import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AllConversation from './AllConversation';
// import MentionedList from './MentionedList';
import { QuestionAnswer } from '@mui/icons-material';
import { Typography, useTheme } from '@mui/material';
import { useStores } from '../../../../use-stores';

// interface TabPanelProps {
//   children?: React.ReactNode;
//   index: number;
//   value: number;
// }

// function CustomTabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ChatList = () => {
  const { chatStore } = useStores();
  const [value, setValue] = React.useState(0);
  const theme = useTheme();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : '#F4F2FF',
        padding: "0px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginLeft: "10px",
          gap: "0px",
          backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : '#F4F2FF',
          marginBottom: "-15px",
        }}
      >
        <QuestionAnswer sx={{ marginTop: "4px" }} />
        <Typography sx={{
          fontWeight: 700, margin: "8px", marginTop: "10px", fontSize: "1.6rem",
          color: theme.palette.mode === 'dark' ? '#F4F2FF' : '#1E1665',
        }}>
          Conversation <span>#{chatStore.currentTaskId}</span>
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="All Messages" {...a11yProps(0)} sx={{ textTransform: 'none', fontWeight: "600", marginLeft: "-5px" }} />
          {/* <Tab label="@Mentioned" {...a11yProps(1)} /> */}
        </Tabs>
      </Box>
      <Box sx={{ padding: "8px" }}>
        {/* <CustomTabPanel value={value} index={0}> */}
        <AllConversation />
        {/* </CustomTabPanel> */}
        {/* <CustomTabPanel value={value} index={1}> */}
        {/* <MentionedList /> */}
        {/* </CustomTabPanel> */}
      </Box>
    </Box>
  );
}

export default ChatList
